import { render, staticRenderFns } from "./u-language-items-icon-text.vue?vue&type=template&id=2c31f899&scoped=true&"
import script from "./u-language-items-icon-text.vue?vue&type=script&lang=js&"
export * from "./u-language-items-icon-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31f899",
  null
  
)

export default component.exports